module.exports = __webpack_public_path__ + "media/images/project/bookmark-box-multiple-outline-9dcaff58119817c71a2afb44449936c8.svg";